import StartPage from '@/page/StartPage';
import SignIn from '@/page/login/SignIn';
import Join from '@/page/join/Join';
import WalletMain from '@/page/wallet/WalletMain';
import WalletDetail from '@/page/wallet/DetailList';
import SendToken from '@/page/wallet/SendToken';
import SendNft from '@/page/wallet/SendNft';
import NftDetail from '@/page/nft/NftDetail';
import PointMain from '@/page/point/PointMain';
import UsageDetails from '@/page/point/UsageDetails';
import Charge from '@/page/point/Charge';
import ChargeInapp from '@/page/point/ChargeInapp';
import Notice from '@/page/my/notice/Notice';
import NoticeDetail from '@/page/my/notice/NoticeDetail';
import AgreeTerms from '@/page/join/AgreeTerms';
import SignUp from '@/page/join/SignUp';
import Wellcome from '@/page/join/Wellcome';
import MyPage from '@/page/my/MyPage';
import TermsPage from '@/page/my/terms';
import TermsDetailPage from '@/page/my/terms/detail';
import SendForm from '@/page/wallet/SendForm';
import NftMain from '@/page/nft/NftMain';
import SecurityCenter from '@/page/my/security-center/SecurityCenter';
import LoginHistory from '@/page/my/security-center/LoginHistory';
import AccountDelete from '@/page/my/security-center/account/AccountDelete';
import ChangePw from '@/page/my/security-center/password/ChangePw';
import Setting from '@/page/my/settings/Setting';
import EventPage from '@/page/my/event/EventPage';
import EventDetail from '@/page/my/event/EventDetail';
import Qrcode from '@/page/qrcode/Qrcode';
import AuthLevel from '@/page/my/auth-level';
import RegisterPin from '@/page/join/RegisterPin';
import PinSignIn from '@/page/login/PinSignIn';
import PinSetting from '@/page/my/pin/PinSetting';
import PinCheck from '@/page/my/pin/PinCheck';
import FindPw from '@/page/login/FindPw';
import ResetPw from '@/page/login/ResetPw';
import OutLink from '@/page/OutLink';

import SendLinkModal from '@/component/wallet/send-link-modal';
import Oauth from '@/page/Oauth';
import SignInSns from '@/page/login/SignInSns';
import SignInEmail from '@/page/login/SignInEmail';
import PinComponent from '@/page/my/pin/PinComponent';
import BioAuthComponent from '@/page/my/bio/BioAuthComponent';
import SendSuccess from '@/page/wallet/SendSuccess';
import SendFail from '@/page/wallet/SendFail';
import TxHistory from '@/page/wallet/TxHistory';
// import BoardView from '@/page/my/notice/BoardView';

// import OtcList from '../../page/user/OtcList';

export default function RouterList() {
  return [
    {
      name: 'startPage',
      url: '/',
      element: <StartPage />,
      private: false,
    },
    {
      name: 'outLink',
      url: '/outLink*',
      element: <OutLink />,
      private: false,
    },
    {
      name: 'oauth',
      url: '/oauth',
      element: <Oauth />,
      private: false,
    },
    // {
    //   name: 'outLink',
    //   url: '/outLink/:path',
    //   element: <OutLink />,
    //   private: false,
    // },
    {
      name: 'agreeTerms',
      url: '/agreeTerms',
      element: <AgreeTerms />,
      private: false,
    },
    {
      name: 'signUp',
      url: '/signUp',
      element: <SignUp />,
      private: false,
    },
    {
      name: 'wellcome',
      url: '/wellcome',
      element: <Wellcome />,
      private: false,
    },
    {
      name: 'signIn',
      url: '/signIn',
      element: <SignInSns />,
      private: false,
    },
    {
      name: 'signInSns',
      url: '/signInSns',
      element: <SignInSns />,
      private: false,
    },
    {
      name: 'signInEmail',
      url: '/signInEmail',
      element: <SignInEmail />,
      private: false,
    },
    {
      name: 'pinSignIn',
      url: '/pinSignIn',
      element: <PinSignIn />,
      private: false,
    },
    {
      name: 'join',
      url: '/join',
      element: <Join />,
      private: false,
    },
    {
      name: 'registerPin',
      url: '/registerPin',
      element: <RegisterPin />,
      private: false,
    },
    {
      name: 'findPw',
      url: '/findPw',
      element: <FindPw />,
      private: false,
    },
    {
      name: 'resetPw',
      url: '/resetPw',
      element: <ResetPw />,
      private: false,
    },

    // {
    //   name: 'signIn',
    //   url: '/index.html',
    //   type: 'signIn',
    //   element: <SignIn />,
    //   private: false,
    // },
    // {
    //   name: 'signIn',
    //   url: '',
    //   type: 'signIn',
    //   element: <SignIn />,
    //   private: false,
    // },
    {
      name: 'wallet',
      url: '/wallet',
      element: <WalletMain />,
      private: true,
    },
    {
      name: 'walletDetail',
      url: '/walletDetail',
      element: <WalletDetail />,
      private: true,
    },
    {
      name: 'txHistory',
      url: '/txHistory',
      element: <TxHistory />,
      private: true,
    },
    {
      name: 'send',
      url: '/send',
      element: <SendToken />,
      private: true,
    },
    {
      name: 'sendForm',
      url: '/sendForm',
      element: <SendForm />,
      private: true,
    },
    {
      name: 'sendNft',
      url: '/sendNft',
      element: <SendNft />,
      private: true,
    },
    {
      name: 'notice',
      url: '/notice',
      element: <Notice />,
      private: true,
    },
    {
      name: 'noticeDetail',
      url: '/noticeDetail/:path',
      element: <NoticeDetail />,
      private: true,
    },
    {
      name: 'event',
      url: '/event',
      element: <EventPage />,
      private: true,
    },
    {
      name: 'eventDetail',
      url: '/eventDetail/:path',
      element: <EventDetail />,
      private: true,
    },

    {
      name: 'nft',
      url: '/nft',
      element: <NftMain />,
      private: true,
    },
    {
      name: 'nftDetail',
      url: '/nftDetail',
      element: <NftDetail />,
      private: true,
    },
    {
      name: 'point',
      url: '/point',
      element: <PointMain />,
      private: true,
    },
    {
      name: 'pointDetail',
      url: '/pointDetail',
      element: <UsageDetails />,
      private: true,
    },
    {
      name: 'charge',
      url: '/charge',
      element: <Charge />,
      private: true,
    },
    {
      name: 'charge2',
      url: '/charge2',
      element: <ChargeInapp />,
      private: true,
    },
    {
      name: 'my',
      url: '/my',
      element: <MyPage />,
      private: true,
    },
    {
      name: 'terms',
      url: '/terms',
      element: <TermsPage />,
      private: true,
    },
    {
      name: 'terms',
      url: '/terms/:path',
      element: <TermsPage />,
      private: false,
    },
    {
      name: 'termsId',
      url: `/terms/:path/:type`, // `${path}`, // /terms/:path
      element: <TermsDetailPage />,
      private: false,
    },
    {
      name: 'securityCenter',
      url: '/securityCenter',
      element: <SecurityCenter />,
      private: true,
    },
    {
      name: 'loginHistory',
      url: '/loginHistory',
      element: <LoginHistory />,
      private: true,
    },

    {
      name: 'delete',
      url: '/delete',
      element: <AccountDelete />,
      private: true,
    },
    {
      name: 'changePw',
      url: '/changePw',
      element: <ChangePw />,
      private: true,
    },
    {
      name: 'setting',
      url: '/setting',
      element: <Setting />,
      private: true,
    },
    {
      name: 'qrcode',
      url: '/qrcode',
      element: <Qrcode />,
      private: true,
    },
    {
      name: 'authLevel',
      url: '/authLevel',
      element: <AuthLevel />,
      private: true,
    },
    {
      name: 'pinSetting',
      url: '/pinSetting',
      element: <PinSetting />,
      private: true,
    },
    {
      name: 'pinCheck',
      url: '/pinCheck',
      element: <PinCheck />,
      private: true,
    },
    {
      name: 'pinCheck',
      url: '/pinCheck/:path',
      element: <PinCheck />,
      private: true,
    },
    {
      name: 'pinComponent',
      url: '/pinComponent',
      element: <PinComponent />,
      private: true,
    },
    {
      name: 'bioAuthComponent',
      url: '/bioAuthComponent',
      element: <BioAuthComponent />,
      private: true,
    },
    {
      name: 'sendSuccess',
      url: '/sendSuccess',
      element: <SendSuccess />,
      private: true,
    },
    {
      name: 'sendFail',
      url: '/sendFail',
      element: <SendFail />,
      private: true,
    },
    // {
    //   name: 'boardView',
    //   url: '/boardView/:path',
    //   element: <BoardView />,
    //   private: false,
    // },
  ];
  // return LinkList;
}
